import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app/app.routes';
import { environment } from './environments/environment';
import { AppConfig } from './app/Shared/app-config.inject';
import { registerLicense } from '@syncfusion/ej2-base';
import { importProvidersFrom } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TokenInterceptor } from './app/Shared/token.interceptor';

const requestOrigin = window.location.origin;

function bootstrapApp() {
  const req = new XMLHttpRequest();
  req.addEventListener('load', (res: any) => {
    const appConfig = JSON.parse(res.currentTarget.response);
    environment.syncfusionKey = appConfig.syncfusionKey;
    environment.apiBaseUrl = appConfig.apiBaseUrl;
    environment.production = appConfig.production;
    registerLicense(environment.syncfusionKey);
    
    environment.apiBaseUrl = requestOrigin + "/api";
    console.log("baseURL = ", environment.apiBaseUrl);
    bootstrapApplication(AppComponent, {
      providers: [
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        {
          provide: HTTP_INTERCEPTORS,
          useClass: TokenInterceptor,
          multi: true
        },
        CurrencyPipe,
        DatePipe,
        provideRouter(appRoutes),
        provideHttpClient(), // 🔧 Required for any HTTP services
        {
          provide: AppConfig,
          useValue: { ...appConfig }
        },
        importProvidersFrom(
          ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
          })
        )
      ]
    }).catch(err => console.error(err));
  });

  req.open('GET', '/assets/config/config.json');
  req.send(null);
}

bootstrapApp();
